<script>
import getFile from '@/lib/get-file';

export default {
  name: 'FaultEventsChartMixin',
  methods: {
    generateArraysOfTicks(series) {
      const foundedThresholds = series.reduce(
        (reducer, { data, group }) => {
          for (const value of data) {
            if (value > reducer[group].threshold) reducer[group].threshold = value;
            else if (-1 * value > reducer[group].threshold) reducer[group].threshold = -1 * value;
          }
          return reducer;
        },
        { Current: { threshold: 0 }, Voltage: { threshold: 0 } }
      );

      const {
        Current: { threshold: currentThreshold },
        Voltage: { threshold: voltageThreshold }
      } = foundedThresholds;

      const currentStep = (this.roundUp(currentThreshold) + 100) / 3;
      const voltageStep = (this.roundUp(voltageThreshold) + 100) / 3;

      return {
        current: this.generateArrayOfTicks(currentStep),
        voltage: this.generateArrayOfTicks(voltageStep)
      };
    },
    getFaultCSV() {
      const filename = `${this.timestampFormatted}.csv`;

      getFile(this.generateFaultEventCSVPath(), filename);
    }
  }
};
</script>
